var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32032 3.77417V7.35483H15.6824C17.5229 7.35483 18.1364 7.9516 18.1364 9.74193V16.9033H15.6824V14.5161C15.6824 12.7258 15.0689 12.129 13.2284 12.129H8.32032V15.7097L0.958252 9.74193L8.32032 3.77417Z",
    fill: "url(#paint0_linear_152_3293)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9339 2.5V6.75802H15.6825C16.6367 6.75802 17.4681 6.90503 18.0335 7.455C18.5989 8.00496 18.75 8.81368 18.75 9.74191V17.5H15.069V14.5161C15.069 13.654 14.9133 13.2692 14.7118 13.0732C14.5103 12.8772 14.1147 12.7258 13.2284 12.7258H8.9339V16.9838L0 9.74191L8.9339 2.5ZM1.91665 9.74191L7.70689 14.4355V11.5322H13.2284C14.1827 11.5322 15.0141 11.6792 15.5795 12.2292C16.1448 12.7792 16.296 13.5879 16.296 14.5161V16.3064H17.523V9.74191C17.523 8.8798 17.3674 8.49497 17.1659 8.29896C16.9644 8.10296 16.5687 7.95158 15.6825 7.95158H7.70689V5.04829L1.91665 9.74191Z",
    fill: "#222627"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_3293",
    x1: 9.54734,
    y1: 3.77417,
    x2: 9.54734,
    y2: 16.9033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BBC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo20);
export default __webpack_public_path__ + "static/media/undo_20.b39d145550b74a348b97efb41aa48b09.svg";
export { ForwardRef as ReactComponent };